import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompareReportViewComponent } from '../compare-report-view.component';

/**
 * Audit Log tab component
 * Displays the audit logs panel content for comparison
 * Renders the auditLogsTemplate from the parent component
 */
@Component({
    selector: 'app-compare-audit-log-tab',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="flex flex-col w-full h-full">
            @if (parentComponent && parentComponent.auditLogsTemplateRef) {
                <ng-container *ngTemplateOutlet="parentComponent.auditLogsTemplateRef"></ng-container>
            }
        </div>
    `
})
export class CompareAuditLogTabComponent implements OnInit {
    @Input() parentComponent?: CompareReportViewComponent;

    ngOnInit() {
        // Component initialized
    }
}

